import src from "IMAGE";
export default { src, width: 112, height: 207, blurWidth: 4, blurHeight: 8, blurDataURL: "data:image/webp;base64,UklGRnoAAABXRUJQVlA4TG4AAAAvA8ABEM1VICICHsgmAAAAAIABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHoAACDCAwEkAAAAADj/Hw833QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMkIIlVXowzCI5ggy/Pw=="};
